import { useEffect, useState } from 'react';
import OrderController from '@/services/OrderController';
import useInterval from '@/utils/useInterval';

export const useOperationStatus = user => {
	const [operating, setOperating] = useState(null);
	const [notOperatingReason, setNotOperatingReason] = useState(null);
	const [warningMessage, setWarningMessage] = useState(null);
	const [warningMessageVisible, setWarningMessageVisible] = useState(true);

	const getOperationStatus = async () => {
		const res = await OrderController.getOperationStatus(user?.cityLocation?.id);

		setOperating(res?.operating);
		setNotOperatingReason(res?.notOperatingReason);
		setWarningMessage(res?.warningMessage || null);
	};

	useEffect(() => {
		if (user) {
			getOperationStatus();
		}
	}, [user]);

	useInterval(getOperationStatus, 60_000);

	const isOperating = operating !== false;

	return {
		operating,
		setOperating,
		notOperatingReason,
		setNotOperatingReason,
		warningMessage,
		setWarningMessage,
		warningMessageVisible,
		setWarningMessageVisible,
		isOperating,
		getOperationStatus,
	};
};
